import { useState, useTransition } from 'react';

import { useBoundStore } from 'app/store';

import { useCheckVaildSubmit, useInitCcrcInputs } from '../../lib';
import { CcrcDetail } from '../CcrcDetail';

import './ccrcModal.css';

/**
 * if만 필요 hspCd, hspId
 */
export const CcrcModal = ({ header, title, desc, hspCd, hspId, ccrcItemList, handleClick, centerContent }) => {
  const setAllCcrcInputs = useBoundStore((store) => store['ccrcModal'].setAllCcrcInputs);
  const ccrcGuidId = useBoundStore((store) => store['ccrcModal'].ccrcGuidId);
  const setCcrcGuidId = useBoundStore((store) => store['ccrcModal'].setCcrcGuidId);
  const [showDetail, setShowDetail] = useState(false);
  const [isPending, startTransition] = useTransition();
  const [ccrcInputs, setCcrcInputs] = useInitCcrcInputs({ ccrcItemList });
  const [isVaildSubmit, allChecked] = useCheckVaildSubmit({ ccrcInputs });

  const handleSubmit = () => {
    const newCcrcItemList = ccrcItemList.map((item) => {
      // 삼육대 강제 체크
      const newItem = {
        ...item,
        ccrcYn: item['ccrcGuidId'] === '33' ? 'Y' : ccrcInputs[item['ccrcGuidId']].checked ? 'Y' : 'N',
      };
      return newItem;
    });

    handleClick(newCcrcItemList);
  };

  const handleDetailSubmit = () => {
    startTransition(() => {
      setShowDetail(false);
      setCcrcInputs({
        id: ccrcGuidId,
        checked: true,
      });
    });
  };

  const handleShowDetail = (guidId) => {
    startTransition(() => {
      setCcrcGuidId(guidId);
      setShowDetail(true);
    });
  };

  return (
    <>
      <div className='common-agree-popup-backdrop'>
        {showDetail ? (
          <CcrcDetail params={{ ccrcGuidId, hspCd, hspId }} handleSubmit={handleDetailSubmit} />
        ) : (
          <div className='common-agree-popup common-agree-popup--bottom'>
            <div className='common-agree-popup-wrap'>
              <div className='title-wrap'>
                {header && (
                  <span className='hsp-badge-wrap'>
                    <span className='hsp-badge'>{header}</span>
                  </span>
                )}
                <h3 className='title'>{title}</h3>
                <p className='sub-text'>{desc}</p>
              </div>
              <div className='contents-wrap'>
                {centerContent}
                <div className='agree-chk-form'>
                  <div className='agree-chk-list'>
                    {ccrcItemList.map(({ ccrcGuidId, ccrcItem, essnYn, ccrcDspYn, ccrcDtlYn }) => {
                      if (ccrcDspYn === 'Y') {
                        return (
                          <div className='agree-item choice_type3' key={ccrcGuidId}>
                            <input
                              type='checkbox'
                              id={`${ccrcGuidId}_check`}
                              name=''
                              aria-label='개인정보 수집·이용 동의'
                              className='inp_choice'
                              onChange={() => {}}
                              checked={!!ccrcInputs[ccrcGuidId]?.checked}
                              onTouchStart={() => {
                                setCcrcInputs({
                                  id: ccrcGuidId,
                                  checked: !ccrcInputs[ccrcGuidId]?.checked,
                                });
                              }}
                            />
                            <label id='checkLabel31' htmlFor='checkItem31' className='' aria-hidden='false'>
                              <span className='icon icon_check'></span>
                              {essnYn === 'Y' && '[필수] '}
                              {ccrcItem}
                            </label>
                            {ccrcDtlYn !== 'N' && (
                              <button className='detail-btn' type='button' onClick={() => handleShowDetail(ccrcGuidId)}>
                                <span className='icon icon_more'>상세 보기</span>
                              </button>
                            )}
                          </div>
                        );
                      }
                    })}
                  </div>
                  {ccrcItemList.length > 1 && (
                    <div className='agree-chk-all'>
                      <div className='agree-chk-all-wrap choice_type2'>
                        <input
                          type='checkbox'
                          className='inp_choice'
                          aria-label='모두 동의'
                          checked={allChecked}
                          onChange={() => {}}
                          onTouchStart={() => {
                            setAllCcrcInputs({
                              checked: !allChecked,
                            });
                          }}
                        />
                        <label id='' className='' aria-hidden='false' htmlFor='allCheck'>
                          <span className='icon item_agree_check'></span>전체 동의
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='popup-btn-wrap'>
                <button
                  className={`btn${isVaildSubmit ? ' highlight' : ''}`}
                  disabled={!isVaildSubmit}
                  onClick={handleSubmit}
                >
                  <span>동의하기</span>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
